import React, { useEffect } from 'react'
import {
	AppShell,
	Navbar,
	Header,
	Text,
	Button,
	Group,
	Burger,
	MediaQuery,
	useMantineTheme,
} from '@mantine/core'
import { Outlet, useLocation } from 'react-router-dom'
import { logout } from '../services/actions/authActions'
import Sidebar from '../components/Sidebar'
import AppInitializer from '../components/AppInitializer'
import ExperienceInitializer from '../components/ExperienceInitializer'
import { useDisclosure } from '@mantine/hooks'

const PrivateLayout = () => {
	const location = useLocation()
	const theme = useMantineTheme()
	const [opened, { toggle, close }] = useDisclosure(false)

	useEffect(() => {
		close()
	}, [location.pathname])

	return (
		<>
			<AppInitializer />
			<ExperienceInitializer />

			<AppShell
				navbarOffsetBreakpoint='sm'
				navbar={
					<Navbar
						p='md'
						hiddenBreakpoint='sm'
						hidden={!opened}
						width={{ sm: 250, lg: 300 }}
					>
						<Sidebar />
					</Navbar>
				}
				header={
					<Header height={60} p='xs'>
						<Group position='apart' sx={{ height: '100%' }}>
							<MediaQuery largerThan='sm' styles={{ display: 'none' }}>
								<Burger
									opened={opened}
									onClick={toggle}
									size='sm'
									color={theme.colors.gray[6]}
									mr='xl'
								/>
							</MediaQuery>

							<Text fw={700}>LiveHQ</Text>

							<Button variant='outline' color='red' size='xs' onClick={logout}>
								Logout
							</Button>
						</Group>
					</Header>
				}
				padding='md'
			>
				<Outlet />
			</AppShell>
		</>
	)
}

export default PrivateLayout
